import type { Filters } from './filters';

const _priceLow = [
  { label: 'No min', value: '' },
  { label: '$100K', value: '100000' },
  { label: '$200K', value: '200000' },
  { label: '$300K', value: '300000' },
  { label: '$400K', value: '400000' },
  { label: '$500K', value: '500000' },
  { label: '$600K', value: '600000' },
  { label: '$700K', value: '700000' },
  { label: '$800K', value: '800000' },
  { label: '$900K', value: '900000' },
  { label: '$1M', value: '1000000' },
];

export function PriceLowOptions(
  this: Filters,
): { disabled: boolean; label: string; value: string }[] {
  return _priceLow.map((o) => ({
    ...o,
    disabled:
      o.value !== '' &&
      this.filteringService.priceHigh() !== '' &&
      parseInt(o.value) >= parseInt(this.filteringService.priceHigh()),
  }));
}
